/** @jsxImportSource @emotion/react */

import { Avatar } from '@mui/material'
import { findMyUser_findMyUser as UserData } from '__generatedTypes__/findMyUser'
import { ROLE_TITLE } from 'pagesNew/Users'
import { RolesEnum } from '__generatedTypes__/globalTypes'
import { ReactComponent as LogoutIcon } from '../icons/logout.svg'
import * as classes from './styles'

type Props = {
  user?: UserData | null
  onSignOut: () => void
}

const getRoleTitle = (role?: string | null) => {
  if (!role) {
    return 'Administrator'
  }

  return ROLE_TITLE[role as RolesEnum] || 'Administrator'
}

export const User = ({ user, onSignOut }: Props) => (
  <div css={classes.wrapper}>
    <Avatar src={user?.getAvatar?.photo ?? undefined} alt="Avatar" />
    <div css={classes.content}>
      <div css={classes.name}>
        {user?.firstName || ''} {user?.lastName || ''}
      </div>
      <div>{getRoleTitle(user?.role)}</div>
    </div>
    <LogoutIcon onClick={onSignOut} className="logout" />
  </div>
)
